module.exports = __webpack_public_path__ + "static/media/aliens.ad1dff00.svg";